import React, { useContext } from "react";
import { ApplyContext } from "~/pages/applyFormMange/ApplyRegContext";
import { useTranslation } from "react-i18next";

const InquiryAgree = ({ card }) => {
	const { t } = useTranslation();
	const { setListByTarget } = useContext(ApplyContext);

	const handleChange = (e) => {
		setListByTarget({ ...card, title: e.target.value });
	};

	const handleDetailChange = (e) => {
		setListByTarget({ ...card, description: e.target.value });
	};

	const handleAgrrDetailChange = (e) => {
		setListByTarget({ ...card, agreeDescription: e.target.value });
	};

	return (
		<>
			<div className="c__form horiz">
				<div className="f__group export-label">
					<div className="f__control">
						<input
							name="inquiryAgree"
							className="c__input f__item"
							placeholder={t(
								"pages.round.RoundReg.Inquiry.content.cardType.InquiryAgree.question"
							)}
							type="text"
							value={card.title}
							onChange={handleChange}
						/>
					</div>
				</div>
				<div className="f__group">
					<div className="f__control">
						<textarea
							name="agreeContent"
							className="c__textarea f__item "
							placeholder={t(
								"pages.round.RoundReg.Inquiry.content.cardType.InquiryAgree.input"
							)}
							value={card.description}
							onChange={handleDetailChange}
						/>
					</div>
				</div>
				<div className="f__group ">
					<div className="f__control-wrap">
						<label className="checkbox-custom">
							<input type="checkbox" />
							<span className="checkmark" />
						</label>
						<div className="f__control export-input">
							<input
								name="inquiryAgreeChk"
								className="c__input f__item"
								placeholder={t(
									"pages.round.RoundReg.Inquiry.content.cardType.InquiryAgree.privacyPolicy"
								)}
								type="text"
								value={card.agreeDescription}
								onChange={handleAgrrDetailChange}
							/>
						</div>
					</div>
				</div>
			</div>

			{/*<Form useForm={inquiryForm}>*/}
			{/*	<Input*/}
			{/*		name="inquiryAgree"*/}
			{/*		placeholder="질문"*/}
			{/*		className="export-label"*/}
			{/*		// value={card.title}*/}
			{/*	/>*/}
			{/*	<Textarea name="agreeContent" placeholder="내용입력" />*/}
			{/*	<Group>*/}
			{/*		<label className={`checkbox-custom`}>*/}
			{/*			<input type="checkbox" />*/}
			{/*			<span className="checkmark" />*/}
			{/*		</label>*/}
			{/*		<Input*/}
			{/*			name="inquiryAgreeChk"*/}
			{/*			placeholder="개인정보수집 및 활용에 동의합니다"*/}
			{/*			className="export-input"*/}
			{/*		/>*/}
			{/*	</Group>*/}
			{/*</Form>*/}
		</>
	);
};

export default InquiryAgree;
